<script setup lang="ts">
import { computed } from "vue"
import auFlag from "flag-icons/flags/4x3/au.svg?url"
import brFlag from "flag-icons/flags/4x3/br.svg?url"
import caFlag from "flag-icons/flags/4x3/ca.svg?url"
import deFlag from "flag-icons/flags/4x3/de.svg?url"
import gbFlag from "flag-icons/flags/4x3/gb.svg?url"
import jpFlag from "flag-icons/flags/4x3/jp.svg?url"
import sgFlag from "flag-icons/flags/4x3/sg.svg?url"
import usFlag from "flag-icons/flags/4x3/us.svg?url"
import xxFlag from "flag-icons/flags/4x3/xx.svg?url"

const flagUrls: Record<string, string> = {
  au: auFlag,
  br: brFlag,
  ca: caFlag,
  de: deFlag,
  gb: gbFlag,
  jp: jpFlag,
  sg: sgFlag,
  us: usFlag
}

const props = defineProps<{
  country: string
}>()

const normalizedCountry = computed(() => props.country.trim().toLowerCase())
const flagUrl = computed(() => flagUrls[normalizedCountry.value] ?? xxFlag)
const flagStyle = computed(() => ({ backgroundImage: `url("${flagUrl.value}")` }))
</script>

<template>
  <UTooltip :text="country" :ui="{ content: 'dashboard-tooltip-content', text: 'dashboard-tooltip-text' }">
    <span class="dashboard-country-flag-trigger" :aria-label="country">
      <span class="dashboard-country-flag" :style="flagStyle" aria-hidden="true" />
    </span>
  </UTooltip>
</template>
